import React, { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import useTheme from '@mui/material/styles/useTheme';

import ReactJson from 'react-json-view';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { EntityHistoryJsonContext_entry$key } from '__generated__/EntityHistoryJsonContext_entry.graphql';

type Props = {
  entry: EntityHistoryJsonContext_entry$key;
};

const EntityHistoryJsonContext: FC<Props> = ({ entry }) => {
  const theme = useTheme();

  const { context } = useFragment(
    graphql`
      fragment EntityHistoryJsonContext_entry on LogEntry {
        context
      }
    `,
    entry
  );

  if (!context) return null;

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="caption">Kontekstas:</Typography>

      <ReactJson
        collapsed
        name={false}
        displayDataTypes={false}
        displayObjectSize={false}
        collapseStringsAfterLength={50}
        theme={theme.palette.mode === 'dark' ? 'twilight' : 'rjv-default'}
        src={JSON.parse(context)}
      />
    </Box>
  );
};

export default EntityHistoryJsonContext;
